import { reconcileRxChange } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { ReconcileRxChangeRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchReconcileRxChange(
  rxChangeId: number,
  userId: string,
  data: ReconcileRxChangeRequestT,
  signal?: AbortSignal
): Promise<unknown> {
  const config = await createLotusRequestConfig({ signal });
  const response = await reconcileRxChange(rxChangeId, userId, data, config);
  return lotusHealthZod.reconcileRxChangeResponse.parse(response.data);
}
